import * as React from "react";
import styled from "@emotion/styled";
import { Box, H3, Text } from "atoms";
import { OpenCallCard } from "./OpenCallCard";
import { useOpenCalls } from "../api/useOpenCalls";
import {
  categorizeOpenCalls,
  sortOpenCalls,
} from "../utils/categorizeOpenCalls";
import { useUsersOpenCallVotes } from "../api/useUsersOpenCallVotes";

function CurationCornerOpenCalls({ title }: { title: React.ReactNode }) {
  const { data: openCalls } = useOpenCalls({
    isCommunityCuration: true,
    perPage: 999,
    status: "PUBLISHED",
  });
  const { data: votedIds } = useUsersOpenCallVotes();
  const unvotedOpenCalls = React.useMemo(() => {
    const categorized = categorizeOpenCalls(openCalls?.data ?? []);
    const sorted = sortOpenCalls(categorized);
    return sorted.voting.filter((oc) => !votedIds?.openCallIds.includes(oc.id));
  }, [openCalls, votedIds]);

  return (
    <div>
      {title}
      {unvotedOpenCalls.length ? (
        <OpenCallCardGrid>
          {unvotedOpenCalls.map((openCall) => (
            <OpenCallCard key={openCall.id} openCall={openCall} linkToVote />
          ))}
        </OpenCallCardGrid>
      ) : (
        <Box>
          <H3 size="md" textAlign="center">
            Come Back Soon
          </H3>
          <Text size="xs" textAlign="center">
            You are caught up on voting for Open Calls. Check back later when
            more Open Calls are ready for&nbsp;voting.
          </Text>
        </Box>
      )}
    </div>
  );
}

const OpenCallCardGrid = styled.div(({ theme }) => ({
  display: "grid",
  gap: theme.spacing.gap,
  [theme.breakpoints.xs]: {
    gridTemplateColumns: `repeat(2, calc(50% - (${theme.spacing.gap} * .5)))`,
  },
  [theme.breakpoints.desktop]: {
    gridTemplateColumns: `repeat(3, calc((100% / 3) - (${theme.spacing.gap} * .667)))`,
  },
}));
export { CurationCornerOpenCalls };
